@if (tipo === 'sms') {
  <div class="sms-preview">
    <div class="sms-remetente-linha">
      <span class="sms-icone">SMS</span>
      <span class="sms-remetente">Mensagem de texto</span>
    </div>
    <div class="sms-conversa">
      <div class="sms-bolha">
        <span class="quebra-linha">{{ corpoSms || 'A mensagem do template aparecerá aqui.' }}</span>
      </div>
      <span class="sms-hora">agora</span>
    </div>
  </div>
} @else {
  <div class="flex-direction-column gap-5 wrap center-center container-mensagem-exibicao">
    @for (componente of template.components; track componente.id) {
      <div class="width-100">
        @if (componente.type === "HEADER") {
          @switch (componente.format){
            @case ('TEXT'){
              <span class="font-16 weight-600 quebra-linha">{{ componente.text }}</span>
            }
            @case ('IMAGE'){
              @if (blob) {
                <img class="midia-card" [src]="blob" alt="Pré-visualização da imagem">
              }
            }
            @case ('VIDEO'){
              @if (blob) {
                <video class="midia-card" controls [src]="blob" style="border: none;">
                  Seu navegador não suporta a tag de vídeo.
                </video>
              }
            }
            @case ('DOCUMENT'){
              @if (blob) {
                <iframe class="midia-card" [src]="blob" style="border: 1px solid #ccc;"></iframe>
              }
            }
          }
        }
      </div>

      <div class="width-100">
        @if (componente.type === "BODY") {
          <span class="font-16 weight-400 quebra-linha">{{ componente.text }}</span>
        }
        @if (componente.type === "FOOTER") {
          <span class="font-14 weight-400 quebra-linha">{{ componente.text }}</span>
        }
      </div>

      <div class="width-100 flex-direction-column gap-10">
        @if (componente.type === "BUTTONS") {
          @for (btn of componente.buttons; track btn) {
            <div>
              <button class="btn-exibicao flex center-center">{{ btn.text }}</button>
            </div>
          }
        }
      </div>
    }
  </div>
}
